/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";
import { CmsConfig } from "cms/config";

// const base = `${window.location.protocol}//${window.location.host}`
const base = `${CmsConfig.WEBSITE_URL}`;

export const b2cPolicies = {
    names: {
        signUpSignIn: "B2C_1A_SIGNUP_SIGNIN",
        editProfile: "B2C_1A_PROFILEEDIT",
        passwordReset: "B2C_1A_PASSWORDRESET"
    },
    authorities: {
        signUpSignIn: {
            authority: "https://simplicitycustomer.b2clogin.com/simplicitycustomer.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN",
        },
        editProfile: {
            authority: "https://simplicitycustomer.b2clogin.com/simplicitycustomer.onmicrosoft.com/B2C_1A_PROFILEEDIT"
        },
        passwordReset: {
            authority: "https://simplicitycustomer.b2clogin.com/simplicitycustomer.onmicrosoft.com/B2C_1A_PASSWORDRESET"
        }
    },
    authorityDomain: "simplicitycustomer.b2clogin.com"
};

/**
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
        clientId: "e132eee9-33f5-4165-8bfe-d73d47a8789a",
        authority: b2cPolicies.authorities.signUpSignIn.authority,
        knownAuthorities: [b2cPolicies.authorityDomain],
        redirectUri: `${base}/services`,
        postLogoutRedirectUri: `${base}/logout`, // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    // auth: {
    //     clientId: 'e132eee9-33f5-4165-8bfe-d73d47a8789a', // This is the ONLY mandatory field that you need to supply.
    //     // authority: 'https://login.microsoftonline.com/5f4531af-c6f5-4640-a9e3-cf2467755ed7', // Defaults to "https://login.microsoftonline.com/common"
    //     authority: 'https://simplicitycustomer.b2clogin.com/simplicitycustomer.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN', // Defaults to "https://login.microsoftonline.com/common"
    //     redirectUri: `${base}/services`, // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    //     postLogoutRedirectUri: `${base}/`, // Indicates the page to navigate after logout.
    //     navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    // },
    cache: {
        cacheLocation: "sessionStorage", // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: []
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ["openid", "profile"],
    loginHint: "example@domain.net"
};
